<template>
  <mdb-container fluid>
    
    <section class="section team-section">
      <mdb-row>
        
        <div class="col-md-4 mb-1">
          <div class="card profile-card">
            <div class="avatar z-depth-1-half mb-4">
              <img
                :src="avatar"
                class="rounded-circle"
                :alt="fullName"
              />
            </div>

            <div class="card-body pt-0 mt-0">
              <div class="text-center">
                <h3 class="mb-3 font-weight-bold">
                  <strong v-text="fullName"></strong>
                </h3>
                <h6 class="font-weight-bold blue-text mb-4" v-if="userProfile != null" classv-text="userProfile.Side"></h6>
              </div>

              <ul class="striped list-unstyled">
                <li><strong>موجودی کیف پول : </strong> <span v-text="walletAmount"></span></li>
              </ul>
            </div>
          </div>
          <!--Card-->
        </div>


        <mdb-col md="8">
          
          <mdb-row>
            <mdb-col md="12" class="mb-1">
              <div class="classic-tabs">
                <mdb-tab color="primary">

                  <mdb-tab-item v-for="(item,index) in ds" 
                    :key="item.CompanyId"
                    :active="selectTab == index"
                    @click.native.prevent="selectTab = index"
                    ><span v-text="item.Name"></span></mdb-tab-item
                  >
                  
                </mdb-tab>
                <mdb-tab-content class="mb-5 card">
                  <transition-group name="slide-toggle">
                    <mdb-tab-pane  v-for="(item,index) in ds" 
                      :key="item.CompanyId"
                      v-show="selectTab == index">
                      <mdb-tbl responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>توضیح</th>
                            <th>مبلغ</th>
                            <th>فاکتور</th>
                            <th>اوپراتور</th>
                            <th>تاریخ ثبت</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="transition in item.Transactions" :key="transition.CompanyId">
                            <th scope="row" v-text="transition.WalletTransactionId"></th>
                            <td v-text="transition.Desc"></td>
                            <td v-text="transition.Amount"></td>
                            <td v-text="transition.Invoice"></td>
                            <td v-text="transition.Operator"></td>
                            <td v-text="transition.FirstUpdate"></td>
                          </tr>
                          
                        </tbody>
                      </mdb-tbl>
                    </mdb-tab-pane>
                  </transition-group>
                </mdb-tab-content>
              </div>
            </mdb-col>
          </mdb-row>
        </mdb-col>
        
      </mdb-row>
    </section>
    
    <section>
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>عنوان</th>
                  <th>نام صاحب حساب</th>
                  <th>شماره حساب</th>
                  <th>شماره کارت</th>
                  <th>شماره شبا</th>
                  <th>نام بانک</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>مدیر پروژه شما</td>
                  <td>عباس فرشیدی</td>
                  <td>4759878912</td>
                  <td>6104337830842330</td>
                  <td>490120020000004759878912</td>
                  <td>بانک ملت</td>
                </tr>
                <tr title="برای دسترسی با پشتیبانی تماس بگیرید">
                  <td>2</td>
                  <td>شریک تجاری شما</td>
                  <td>شرکت برنامه نویسان دانش برتر سهند</td>
                  <td class="blur">**********</td>
                  <td class="blur">****************</td>
                  <td class="blur">************************</td>
                  <td>بانک ملت</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbTooltip,
  mdbIcon,
  mdbTab,
  mdbTabItem,
  mdbTabContent,
  mdbTabPane,
  mdbTbl
} from "mdbvue";

import walletApi from "@/api/walletApi";

// eslint-disable-next-line
Chart.defaults.global.defaultFontColor = "#fff";

export default {
  name: "Customers",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbTooltip,
    mdbIcon,
    mdbTab,
    mdbTabItem,
    mdbTabContent,
    mdbTabPane,
    mdbTbl
  },
  data() {
    return {
      avatar: null,
      fullName: null,
      selectTab: "1",
      userProfile: null,
      walletAmount: 0,

      ds:null,
    };
  },
  mounted(){
    
    this.avatar = this.$store.state.config.MainDomain + ''+ this.$store.state.userProfile.Avatar;
    this.fullName = this.$store.state.userProfile.FirstName+' '+this.$store.state.userProfile.LastName;
    this.userProfile =  this.$store.state.userProfile;
    this.walletAmount = this.$store.state.dashboard.WalletAmount;

    walletApi
    .getTransactions()
    .then(({ data }) => {
          this.ds = data;
      },
      (r) => {}
    );

    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-card {
  margin-top: 100px;
}

.profile-card .avatar {
  max-width: 150px;
  max-height: 150px;
  margin: -70px auto 0;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
}

.slide-toggle-enter-active {
  transition: 0.3s ease-in;
  opacity: 1;
  max-height: 500px;
}
.slide-toggle-enter,
.slide-toggle-leave-active {
  opacity: 0;
  max-height: 0;
}
.slide-toggle-leave {
  opacity: 1;
  max-height: 500px;
}
.blur{
  filter: blur(4px);
}
</style>
